import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import { FilterEntity } from '@bingads-webui/filter-entity';
import layoutTemplate from './template/index.pug';
import { createPredicateView } from './predicate-creator';
import { PredicatesListVM } from './viewmodel/index';
import * as defaultTemplates from './default-templates';
import './binding/predicate-value';
import './binding/bootstrap-dropdown';

const defaults = {
  layoutTemplate,
  itemTemplates: defaultTemplates,
};

function validateFilter(filter) {
  if (filter.depth > 2) {
    throw new Error('Filter control doesn\'t support expression trees of depth > 2');
  }
}

export class PredicateList extends Backbone.View {
  get events() {
    return {
      'click .new': 'newItem',
      'click .remove': 'removeItem',
    };
  }

  initialize(options) {
    if (!options.entitySchema) {
      throw new Error('Entity schema must be provided for the filter control');
    }
    this.options = _.extend({
      shortDateFormat: 'M/d/yyyy',
      isComparingEnabled: false,
    }, options);
    this.layoutTemplate = options.layoutTemplate || defaults.layoutTemplate;
    this.itemTemplates = _.defaults({}, options.itemTemplates, defaults.itemTemplates);
    this.predicatesList = {};
    this.ko_model = new PredicatesListVM(_.extend(
      {}, {
        templates: this.itemTemplates,
        i18n: this.options.i18n,
      },
      _.pick(this.options, 'entitySchema', 'shortDateFormat', 'isComparingEnabled', 'maxConditionCount')
    ));

    if (options.selected) {
      this.setFilter(options.selected);
    }

    if (_.isFunction(options.onPredicateChange)) {
      this.ko_model.onChange.subscribe(() => {
        options.onPredicateChange({
          isValid: this.ko_model.validate(),
          predicates: this.getPredicates(),
          predicateCount: this.ko_model.items().length,
        });
      });
    }
  }

  newItem() {
    this.ko_model.newItem();
    const index = this.ko_model.items().length - 1;
    const viewModel = this.ko_model.items()[index];
    const container = this.getContainer(index);

    viewModel.propertyText.subscribe(() => {
      this.resetAndRenderValue(viewModel, container);
    }, this);
    this.renderValue(viewModel, container);
  }

  getContainer(index) {
    const predicateValueContainers = this.$('.predicate-value');
    return $(predicateValueContainers[index]);
  }

  renderValue(viewModel, container) {
    const view = createPredicateView({
      el: container,
      ko_model: viewModel,
      i18n: this.options.i18n,
    });
    this.predicatesList[container] = view.render();
  }

  resetAndRenderValue(viewModel, container) {
    ko.cleanNode(container[0]);
    container.empty();
    viewModel.reset();
    this.renderValue(viewModel, container);
  }


  setFilter(filterEntity) {
    const predicates = [];

    validateFilter(filterEntity);
    if (filterEntity.depth === 1) {
      predicates.push(filterEntity.query);
    } else if (filterEntity.depth > 1) {
      // TODO [andreic] : We don't maintain logicalOperator here.
      // Based on the use cases decide wheter to store it or not
      if (_.isArray(filterEntity.query.$and)) {
        predicates.push(...filterEntity.query.$and);
      }
      if (_.isArray(filterEntity.query.$or)) {
        predicates.push(...filterEntity.query.$or);
      }
    }
    this.ko_model.setPredicates(predicates);
  }

  getFilterQuery(logicalOperator) {
    const predicates = this.getPredicates();
    let filter;

    if (_.isEmpty(predicates)) {
      filter = {};
    } else if (predicates.length === 1) {
      [filter] = predicates;
    } else {
      filter = _.object([logicalOperator || '$and'], [predicates]);
    }

    return filter;
  }

  getPredicates() {
    return this.ko_model.getPredicates();
  }

  setPredicates(predicates) {
    return this.ko_model.setPredicates(predicates);
  }

  showValidationErrors() {
    this.ko_model.showValidationErrors();
  }

  getFilterEntity(logicalOperator) {
    const filterQuery = this.getFilterQuery(logicalOperator);

    return new FilterEntity(filterQuery, _.pick(this.options, [
      'entitySchema',
      'shortDateFormat',
      'ignoreCase',
      'fieldMap',
      'odata',
    ]));
  }

  render() {
    const layout = this.layoutTemplate({
      i18n: this.options.i18n,
      removeTitle: this.options.i18n.getString('Filter_Remove'),
      addTitle: this.options.i18n.getString('Filter_PredicateList_New'),
      performanceText: this.options.i18n.getString('Performance'),
    });
    this.$el.html(layout);
    ko.applyBindings(this.ko_model, this.el);
    _.each(this.ko_model.items(), (item, index) => {
      const container = this.getContainer(index);
      item.propertyText.subscribe(() => {
        this.resetAndRenderValue(item, container);
      }, this);
      this.renderValue(item, container);
    }, this);

    this.$('button:first', this.$el).focus();
    return this;
  }

  clean() {
    this.ko_model.setPredicates([]);
  }

  remove() {
    ko.cleanNode(this.el);
    super.remove();
    return this;
  }

  removeItem(ev) {
    const data = ko.dataFor(ev.target);

    if (data) {
      this.ko_model.removeItem(data);
      const valueDiv = $(ev.target).closest('.predicate-row').find('.predicate-value');
      delete this.predicatesList[valueDiv[0]];
    }
  }
}
